import { render, staticRenderFns } from "./BaseTransferSelect.vue?vue&type=template&id=6491bf30&scoped=true"
import script from "./BaseTransferSelect.vue?vue&type=script&lang=js"
export * from "./BaseTransferSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseTransferSelect.vue?vue&type=style&index=0&id=6491bf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6491bf30",
  null
  
)

export default component.exports